module.exports = __webpack_public_path__ + "static/media/click.233580d8.wav";